import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/profile';
import * as profilePageActions from '../actions/profile';
import * as loginPageActions from '../actions/login';
import { Log } from 'ng2-logger';
import { ProfileService } from '../../api/profile-service';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import { Guid } from 'guid-typescript';
import { IGetChangeLanguage } from '../../models/action/profile';

const T = Translator.create();
const _logger = Log.create('profile Saga');
const _profileService = new ProfileService();

function* setProfileAction(params: any): any {
    try {
        const pageData = yield _profileService.RequestGetProfileAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });

        yield put(profilePageActions.setProfileAction(pageData, params.spinnerId, 'set'));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        yield put(profilePageActions.setProfileAction(null, params.spinnerId, 'set'));
    }
}

function* updateProfileAction(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _profileService.RequestUpdateProfileAsync(params.profileData).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        }).then((responseData) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        });

        if (isError) {
            (errorList) ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_profile_update_error_message'), 'topRight');
        }

        if (!isError) {
            Notification.setNotification('success', T.t('r_profile_update_success_message'), 'topRight');
            yield put(profilePageActions.setProfileAction(params.profileData, params.spinnerId, 'set'));
        }
        yield put(loginPageActions.setUseTimezone(params.profileData.timeZone, params.spinnerId, 'set'))

        if (params.callback) {
            params.callback()
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_profile_update_error_message'), 'topRight');
    }
}

function* updateProfilePhotoAction(params: any): any {
    try {
        yield put(profilePageActions.setProfilePhotoAction({ isProfilePhotoUpload: true, profilePhoto: null, photoKey: null }));
        const pageData = yield _profileService.RequestProfilePhotoUploadAsync(params.profilePhoto).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });
        if (pageData && pageData.length > 0) {
            yield put(profilePageActions.setProfilePhotoAction({ isProfilePhotoUpload: true, profilePhoto: pageData, photoKey: Guid.create().toString() }, params.spinnerId, 'set'));
        } else {
            yield put(profilePageActions.setProfilePhotoAction({ isProfilePhotoUpload: false, profilePhoto: null, photoKey: params.photoKey }, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        yield put(profilePageActions.setProfilePhotoAction({ isProfilePhotoUpload: false, profilePhoto: null, photoKey: params.photoKey }, params.spinnerId, 'set'));
    }
}

function* changePasswordAction(params: any): any {
    try {
        const pageData = yield _profileService.RequestChangePasswordAsync(params.passwordData).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });
        // update success
        if (pageData === true) {
            yield put(profilePageActions.changePasswordSetAction(true, params.spinnerId, 'set'));
            const changePasswordButton = document.getElementById('triggerChangePassword');
            const changePasswordModal = document.getElementById('change-password')
            if (changePasswordModal) {
                const modalClassName = changePasswordModal!.getAttribute('class')
                if (changePasswordButton && modalClassName!.includes('show')) {
                    changePasswordButton.click();
                }
            }
            yield put(loginPageActions.getUserIdentitiy());

        } else {

            yield put(profilePageActions.changePasswordSetAction(false, params.spinnerId, 'set'));
        }
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        yield put(profilePageActions.changePasswordSetAction(false, params.spinnerId, 'set'));
    }
}

function* changePasswordQuestionAction(params: any): any {
    try {
        const pageData = yield _profileService.RequestChangePasswordQuestionAsync(params.passwordQuestionData).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });
        // update success
        if (pageData === true) {
            yield put(profilePageActions.changePasswordQuestionSetAction(true, params.spinnerId, 'set'));
        } else {
            yield put(profilePageActions.changePasswordQuestionSetAction(false, params.spinnerId, 'set'));
        }
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        yield put(profilePageActions.changePasswordSetAction(false, params.spinnerId, 'set'));
    }
}

function* getPreferences(params: any) {
    let isError = false;
    let errorList: any;
    let preferencesData: any;
    try {
        yield _profileService.RequestGetPreferencesAsync().then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            preferencesData = response;
            if (isError) {
                errorList = response;
            }
        });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(profilePageActions.setPreferencesAction(preferencesData.preferences));
            if (params.callback) {
                params.callback();
            }
        }
    } catch (error: any) {
        yield put(profilePageActions.setPreferencesAction([]));
    }
}

function* setPreferences(params: any) {
    let isError = false;
    let errorList: any;
    try {
        yield _profileService.RequestSetPreferencesAsync(params.preferences).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            }
        });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(profilePageActions.getPreferencesAction());
        }
    } catch (error: any) {
        yield put(profilePageActions.getPreferencesAction());
    }
}

function* setLanguage(params: IGetChangeLanguage) {
    let isError = false;
    let errorList: any;
    let requestReturn = false;

    try {
        yield _profileService.RequestSetLanguage(params.lang)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    requestReturn = response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError && requestReturn) {
            yield put(profilePageActions.setChangeLanguageAction(params.lang, params.spinnerId ? params.spinnerId : '', 'set'));
            if (params.callback) {
                params.callback(params.lang);
            }
        }
    } catch (error: any) {
        Notification.setNotification('error', 'Dil değiştirilirken bir hata oluştu/' + error, 'topRight');
    }
}

function* setTimezoneAction(params: any): any {
    try {
        const pageData = yield _profileService.RequestGetTimezoneData(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data.map((timezone: any) => ({
                    value: timezone.id,
                    label: timezone.displayValue,
                }));
            }
        });

        yield put(profilePageActions.setTimezoneAction(pageData, params.spinnerId, 'set'));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        //yield put(profilePageActions.setProfileAction(null, params.spinnerId, 'set'));
    }
}

export function* watchGetProfileData() {
    yield takeEvery(constants.actions.GET_PROFILE, setProfileAction);
    return null;
}

export function* watchUpdateProfileData() {
    yield takeEvery(constants.actions.UPDATE_PROFILE, updateProfileAction);
    return null;
}

export function* watchChangePasswordData() {
    yield takeEvery(constants.actions.CHANGE_PASSWORD, changePasswordAction);
    return null;
}

export function* watchChangePasswordQuestionData() {
    yield takeEvery(constants.actions.CHANGE_PASSWORD_QUESTION, changePasswordQuestionAction);
    return null;
}

export function* watchUpdateProfilePhotoData() {
    yield takeEvery(constants.actions.UPDATE_PROFILE_PHOTO_ACTION, updateProfilePhotoAction);
    return null;
}

export function* watchGetPreferences() {
    yield takeEvery(constants.actions.USER_PREFERENCES_GET, getPreferences);
    return null;
}

export function* watchSetPreferences() {
    yield takeEvery(constants.actions.USER_PREFERENCES_ADDORUPDATE, setPreferences);
    return null;
}

export function* watchSetLanguage() {
    yield takeEvery(constants.actions.USER_GET_LANGUAGE, setLanguage);
    return null;
}

export function* watchGetTimezoneData() {
    yield takeEvery(constants.actions.GET_TIMEZONE, setTimezoneAction);
    return null;
}

//#endregion "Add Assignment Activity End Saga"

export function* ProfileSagas() {
    yield all([
        watchGetProfileData(),
        watchUpdateProfileData(),
        watchChangePasswordData(),
        watchChangePasswordQuestionData(),
        watchUpdateProfilePhotoData(),
        watchGetPreferences(),
        watchSetPreferences(),
        watchSetLanguage(),
        watchGetTimezoneData()
    ]);
}
